import packageJson from '../../package.json';

export const APP_NAME = 'Gas Service Companion';

type CapacitorWindow = Window & {
  Capacitor?: {
    isNativePlatform?: () => boolean;
  };
};

export function getAppVersion(): string {
  return String(packageJson.version ?? '0.0.0');
}

export function getBuildNumber(): string {
  return import.meta.env.VITE_APP_BUILD?.trim() || 'local';
}

export function getReleaseChannel(): string {
  return import.meta.env.VITE_RELEASE_CHANNEL?.trim() || (import.meta.env.PROD ? 'production' : 'development');
}

export function isNativeShell(): boolean {
  if (typeof window === 'undefined') return false;
  const nativeCheck = (window as CapacitorWindow).Capacitor?.isNativePlatform;
  return typeof nativeCheck === 'function' ? Boolean(nativeCheck()) : false;
}

export function isTestFlightFeedbackEnabled(): boolean {
  return import.meta.env.VITE_BETA_FEEDBACK_ENABLED === 'true';
}

function detectDeviceFamily(userAgent: string): string {
  if (/iPhone/i.test(userAgent)) return 'iPhone';
  if (/iPad/i.test(userAgent)) return 'iPad';
  if (/Android/i.test(userAgent)) return 'Android';
  if (/Mac/i.test(userAgent)) return 'Mac';
  if (/Windows/i.test(userAgent)) return 'Windows';
  return 'Unknown device';
}

export function getDeviceInfo(route = typeof window !== 'undefined' ? window.location.pathname : '/'): string {
  if (typeof navigator === 'undefined') {
    return `Route=${route}`;
  }

  const userAgent = navigator.userAgent;
  const screenSize =
    typeof window !== 'undefined' ? `${Math.round(window.innerWidth)}x${Math.round(window.innerHeight)}` : 'unknown';

  return [
    detectDeviceFamily(userAgent),
    navigator.platform || 'platform-unknown',
    navigator.language || 'language-unknown',
    `screen=${screenSize}`,
    `channel=${getReleaseChannel()}`,
    `native=${isNativeShell() ? 'yes' : 'no'}`,
    `route=${route}`
  ].join(' | ');
}
